export default {
  en: "English",
  no: "Norska (Norwegian)",
  sv: "Svenska (Swedish)",
  da: "Dansk (Danish)",
  fi: "Suomi (Finnish)",
  de: "Deutsch (German)",
};
